import palette from './palette'
import { ChipProps, CSSObject } from '@mui/material'



const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: 'white',

        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: palette.grey[400],
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: palette.grey[40],
        },
      },

    }
  },
  MuiTab: {
    styleOverrides:{
      root: {
        textTransform: 'none' as CSSObject['textTransform'],
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        'body-large': 'p',
        'body-small': 'p',
        'body-xsmall': 'p',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        [theme.breakpoints.up('xs')]: {
          // Apply styles for 'md' breakpoint and below
          backdropFilter: 'blur(10px)',
        },
        [theme.breakpoints.up('md')]: {
          // Apply styles for 'md' breakpoint and below
          backdropFilter: 'unset',
        },

        borderBottom: `1px solid ${theme.palette.grey[200]}`,
      }),
    },
  },
  MuiChip: {
    variants: [
      {
        props: { variant: 'filled-success-light' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.success.main,
          backgroundColor: palette.success.light
        }
      },
      {
        props: { variant: 'filled-error-light' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.error.main,
          backgroundColor: palette.error.light
        }
      },
      {
        props: { variant: 'filled-warning-light' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.yellow[800],
          backgroundColor: palette.yellow[200]
        }
      },
      {
        props: { variant: 'filled-neutral-light' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.grey[600],
          backgroundColor: palette.grey[200]
        }
      },
      {
        props: { variant: 'outlined-success' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.success.main,
          backgroundColor: palette.success.light
        }
      },
      {
        props: { variant: 'outlined-error' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.error.main,
          backgroundColor: palette.error.light
        }
      },
      {
        props: { variant: 'outlined-warning' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.yellow[800],
          backgroundColor: palette.yellow[200]
        }
      },
      {
        props: { variant: 'outlined-neutral' } as Partial<ChipProps<'div', {}>>,
        style: {
          color: palette.grey[600],
          backgroundColor: palette.grey[200]
        }
      }

    ]
  },
  MuiButton: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        borderRadius: 8,
        textTransform: 'none',
      } as const,
    },
    variants: [
      {
        props: { variant: 'contained-light' } as any,
        style: {
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
          '&:hover': {
            backgroundColor: palette.grey[500],
            color: palette.text.light,
          },
        },
      },
      {
        props: { variant: 'text-light' } as any,
        style: {
          color: palette.text.light,
          '&:hover': {
            backgroundColor: palette.grey[100],
            color: palette.text.primary,
          },
        },
      },
    ],
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        padding: '16px',
        boxShadow: 'none',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }: any) => {
        const customColors = {
          info: {
            color: '#6B6B1A',
            border: '1px solid #B9B922',
            bgcolor: '#FFFF001A',
            iconColor: '#6B6B1A',
          },
          blue: {
            color: '#003E63',
            border: 'none',
            bgcolor: '#E6EEF4',
            iconColor: '#00598E',
          },
          success: {
            color: '#028B3D',
            border: '1px solid #08C15B',
            bgcolor: '#E6F8EF',
            iconColor: '#028B3D',
          },
          error: {
            color: '#991B1B',
            border: '1px solid #EF4444',
            bgcolor: '#EF44441A',
            iconColor: '#991B1B',
          },
          warning: {
            color: '#854D0E',
            border: '1px solid #F59E0B',
            bgcolor: '#FEF3C7',
            iconColor: '#F59E0B',
          },
        }

        return {
          borderRadius: '8px',
          fontWeight: 500,
          '&.MuiAlert-standardSuccess': {
            ...customColors.success,
            '& .MuiAlert-icon': {
              color: customColors.success.iconColor,
            },
          },
          '&.MuiAlert-standardError': {
            ...customColors.error,
            '& .MuiAlert-icon': {
              color: customColors.error.iconColor,
            },
          },
          '&.MuiAlert-standardWarning': {
            ...customColors.warning,
            '& .MuiAlert-icon': {
              color: customColors.warning.iconColor,
            },
          },
          '&.MuiAlert-standardInfo': {
            ...customColors.info,
            '& .MuiAlert-icon': {
              color: customColors.info.iconColor,
            },
          },
        }
      },
    },
  },
}

export default components
